<template>
  <div class="flexible">
    <v-card
      v-for="e in evaluations"
      :key="e.id"
      class="card-a-puce"
    >
      <v-card-title
        primary-title
        class="headline font-weight-bold eval-title"
      >
        <div class="name">
          {{ e.trainer ? e.trainer.firstname + " " + e.trainer.lastname : e.created_by }}<span v-if="application == Consts.APPLICATION.BEESECURE">&nbsp;-&nbsp;</span><v-rating
            v-if="application == Consts.APPLICATION.BEESECURE"
            background-color="#AAAAAA"
            dense
            large
            readonly
            :value="parseInt(e.school_mark)"
          />
        </div>
        <div>
          <span
            :title="e.working_time_exceeding_reason"
            class="clock"
          ><v-icon :class="{exceeded: parseFloat(e.working_time) > sessionDefaultTimes[e.user_id]}">mdi-clock-time-five-outline</v-icon><span>{{ (""+e.working_time).replace('.',',') }}h</span></span>
        </div>
      </v-card-title>
      <readonly-field
        v-for="f in e.fields"
        :key="f.id"
        :field="f"
      />
      <v-card-actions
        layout="row"
        layout-align="end end"
      >
        <div class="valign-center">
          <span
            v-if="e.updated_at"
            class="mr-10"
          >Updated on {{ formatDateHuman(e.updated_at) }}</span>
          <span
            v-else
            class="mr-10"
          >Created on {{ formatDateHuman(e.created_at) }}</span>
          <v-btn
            v-if="isCoord || isAdmin || e.user_id == user.id"
            flat
            color="primary"
            icon
            @click="$emit('edit', e)"
          >
            <v-icon
              medium
              color="primary"
            >
              {{ session.status != Consts.TOEVALUATE ? 'mdi-eye' : 'mdi-pencil' }}
            </v-icon>
          </v-btn>
          <delete-button
            v-if="isAdmin || isCoord"
            label="this evaluation"
            :disabled="!!e.is_controlled"
            @confirm="deleteEval(e)"
          />
        </div>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
  import DateMixin from '@/mixins/date'
  import Auth from '@/plugins/auth'
  import ReadonlyField from './GenericForm/ReadonlyField'
  import Consts from '@/consts'
  import DeleteButton from "@/components/shared/DeleteButton.vue"

  export default {
    components: {ReadonlyField, DeleteButton},
    mixins: [DateMixin],
    props: {
      application: {
        type: Number,
        required: true
      },
      evaluations: {
        type: Array,
        required: true
      },
      isCoord: {
        type: Boolean,
        required: true
      },
      isAdmin: {
        type: Boolean,
        required: true
      },
      sessionDefaultTimes: {
        type: Object,
        required: true
      },
      session: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        user: null,
        Consts
      }
    },
    mounted() {
      this.user = Auth.user
    },
    methods: {
      editEval(e) {
        console.log(e)
      },
      deleteEval(e) {
        this.$emit("eval:delete", e.id)
      }
    }
  }
</script>
<style scoped lang="sass">
  .flexible
    display: flex
    flex-direction: row
    flex-wrap: wrap

    .card-a-puce
      margin: 5px 10px
      min-width: 400px

  .eval-title
    display: flex
    flex-direction: row
    justify-content: space-between
    align-items: center

    .name
      display: flex
      align-items: center

  .exceeded
    color: tomato

  .clock
    display: flex
    align-items: center

  .mr-10
    margin-right: 10px
</style>
